module.exports = __webpack_public_path__ + "img/msi_70fl.13344497.svg";